import { render, staticRenderFns } from "./BrowseBuildingSekkei.vue?vue&type=template&id=6e1c965c&scoped=true&"
import script from "./BrowseBuildingSekkei.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingSekkei.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingSekkei.vue?vue&type=style&index=0&id=6e1c965c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c965c",
  null
  
)

export default component.exports